import React, { useEffect, useState } from "react";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import useGetAllProjects from '../ReuseApi/useGetAllProjects';
import useGetAllCategories from '../ReuseApi/useGetAllCategories';
import Select from "react-select";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import useGetSubDepartments from "../ReuseApi/useGetSubDepartments";
import { useProjectList } from "../ReuseApi/useProjectList ";
import { taskPriorityOptions } from "../../utils/constant";

const EditTaskModel = (props) => {

  const { show, close, item, } = props;

  // state for data
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [taskpriority, setTaskpriority] = useState("");
  const [departmentName, setDepartmentName] = useState(null);
  const [subDepartment, setSubDepartment] = useState(null);
  const [projectname, setProjectname] = useState(null);
  const [categoryname, setCategoryname] = useState(null);
  const [assignto, setAssignto] = useState(null);
  const [proposedStartDate, setProposedStartDate] = useState("");
  const [proposedEndDate, setProposedEndDate] = useState("");
  const [initialHr, setInitialHr] = useState("");
  const [initialminute, setInitialMinute] = useState("");
  const [errors, setErrors] = useState({});

  // custom hook
  const { allCategoriesOptions } = useGetAllCategories(departmentName, subDepartment);
  const { subDeptOptions } = useGetSubDepartments(departmentName?.value);
  const { projectOptions, departmentOptions } = useProjectList(projectname?.value);

  // validation message
  const handlerValidate = () => {
    let newErrors = {};

    if (!taskName) newErrors.taskName = "Required Field";
    if (!taskpriority) newErrors.taskpriority = "Required Field";
    if (!taskDescription) newErrors.taskDescription = "Required Field";
    if (!projectname) newErrors.projectname = "Required Field";
    if (!departmentName) newErrors.departmentName = "Required Field";
    if (!subDepartment) newErrors.subDepartment = "Required Field";
    // if (!categoryname) newErrors.categoryname = "Required Field";
    if (!proposedStartDate) newErrors.proposedStartDate = "Required Field";
    if (!proposedEndDate) newErrors.proposedEndDate = "Required Field";
    if (!initialHr) newErrors.initialHr = "Required Field";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // toast message
  const toastSuccess = () => {
    toast.success("Update Successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
      toastId: "update-task-success"
    });
  };

  const EstimateHr = () => {
    toast.error("Initial Estimate hr can not be 0.", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
      toastId: "estimate-hr-error"
    });
  }

  useEffect(() => {
    setTaskName(item?.taskName || "");
    setTaskDescription(item?.taskDescription || "");
    setTaskpriority({ label: item?.taskPriority, value: item?.taskPriority });
    setProjectname({ label: item?.projectName, value: item?.projectId });
    setDepartmentName({ label: item?.taskDepartmentName, value: item?.taskDepartmentId });
    setSubDepartment({ label: item?.subDepartmentName, value: item?.subDepartmentId });
    setCategoryname({ label: item?.categoryOfName, value: item?.category_id });
    setAssignto({ label: item?.resourceName, value: item?.resource_id });
    setProposedStartDate(item?.proposedStartDate ? moment(item.proposedStartDate).format("YYYY-MM-DD") : "");
    setProposedEndDate(item?.proposedEndDate ? moment(item.proposedEndDate).format("YYYY-MM-DD") : "");
    setInitialHr(item?.initialEstimateHr || "");
    setInitialMinute(item?.actualHours || "");

  }, [item]);


  // for hours and minute
  const initialEstimateHr = item?.initialEstimateHr || 0;
  const parts = initialEstimateHr.toFixed(2).toString().split(".");
  const integerPart = parseInt(parts[0]) || 0;
  const decimalPart = parseInt(parts[1]) || 0;
  const hours = integerPart;
  const minutes = Math.round((decimalPart / 100) * 60);

  // update task
  const updateTask = async () => {
    if (handlerValidate()) {
      if (parseFloat(initialHr) === 0 && parseFloat(initialminute || 0) === 0) {
        EstimateHr();
      } else {
        let upadatePayload = {
          empId: item?.empId,
          taskId: item?.taskId,
          taskDepartmentId: departmentName?.value,
          taskDepartmentName: departmentName?.label,
          projectId: projectname?.value,
          projectName: projectname?.label,
          taskName: taskName,
          assignBy_id: item?.assignBy_id,
          assignBy_Name: item?.assignBy_Name,
          resourceName: assignto?.label || item?.resourceName,
          resource_id: assignto?.value || item?.resource_id,
          categoryOfName: categoryname?.label || "",
          category_id: categoryname?.value || "",
          proposedStartDate: new Date(proposedStartDate).toISOString().split('T')[0],
          proposedEndDate: new Date(proposedEndDate).toISOString().split('T')[0],
          taskDescription: taskDescription,
          taskPriority: taskpriority?.value,
          initialEstimateHr: initialHr,
          initialEstimateMinutes: initialminute,
          subDepartmentId: subDepartment?.value,
          subDepartmentName: subDepartment?.label,
        };

        await axios.post(process.env.REACT_APP_BASE_URL + "/task/updateTask", upadatePayload)
          .then((res) => {
            toastSuccess();
            setTimeout(() => {
              props.close();
            }, 1000);
          })
          .catch((err) => {
            console.log("Error from update api", err);
          });
      }
    }
  };
  // const updateTask = async (e) => {
  //   if (handlerValidate()) {
  //     if (parseFloat(initialEstimateHr) === 0) {
  //       EstimateHr()
  //     } else {
  //       let upadatePayload = {
  //         empId: item?.empId,
  //         taskId: item?.taskId,
  //         taskDepartmentId: departmentName.value,
  //         taskDepartmentName: departmentName.label,
  //         projectId: projectname.value,
  //         projectName: projectname.label,
  //         taskName: taskName,
  //         assignBy_id: item?.assignBy_id,
  //         assignBy_Name: item?.assignBy_Name,
  //         resourceName: item.resourceName,
  //         resource_id: item?.resource_id,
  //         categoryOfName: categoryname.label,
  //         proposedStartDate: new Date(proposedStartDate).toISOString().split('T')[0],
  //         proposedEndDate: new Date(proposedEndDate).toISOString().split('T')[0],
  //         taskDescription: taskDescription,
  //         taskPriority: taskpriority?.value,
  //         initialEstimateHr: initialEstimateHr,
  //         initialEstimateMinutes: initialminute,
  //         subDepartmentId: subDepartment?.value,
  //         subDepartmentName: subDepartment?.label,
  //       }
  //       await axios.post(process.env.REACT_APP_BASE_URL + "/task/updateTask", upadatePayload)
  //         .then((res) => {
  //           toastSuccess()
  //           setTimeout(() => {
  //             props.close()
  //           }, 1000)
  //         })
  //         .catch((err) => {
  //           console.log("Error from update api", err);
  //         })
  //     }
  //   }
  // }

  return (
    <div>
      <Modal show={show} onHide={close} size="lg" centered>
        <Modal.Header
          closeButton
          style={{
            color: "black",
            width: "100%",
            height: "50px",
            backgroundColor: "#F9D65F",
          }}
        >
          <Modal.Title><h5>Edit Task</h5></Modal.Title>
        </Modal.Header>
        {/* <Modal.Body size="lg">
          <Row className='mb-4'>
            <Col md={4}>
              <Form.Label className="fw-bold">
                Project Name <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={projectname}
                options={projectOptions}
                onChange={(option) => {
                  setProjectname(option);
                  setDepartmentName(null);
                  setSubDepartment(null);
                  setAssignto(null);
                }}
              />
              {errors.projectname && <p className="errMsg">{errors.projectname}</p>}
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">
                Department Name <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={departmentName}
                options={departmentOptions}
                isDisabled={!projectname}
                onChange={(option) => {
                  setDepartmentName(option);
                  setSubDepartment(null);
                  setAssignto(null);
                }}
              />
              {errors.departmentName && <p className="errMsg">{errors.departmentName}</p>}
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">
                SubDepartment Name <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={subDepartment}
                options={subDeptOptions}
                isDisabled={!departmentName}
                onChange={(option) => setSubDepartment(option)}
              />
              {errors.subDepartment && <p className="errMsg">{errors.subDepartment}</p>}
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md={4}>
              <Form.Label className="fw-bold">
                Category <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={categoryname}
                options={allCategoriesOptions}
                onChange={(option) => setCategoryname(option)}
              />
              {errors.categoryname && <p className="errMsg">{errors.categoryname}</p>}
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">Assign By</Form.Label>
              <Form.Control value={item?.assignBy_Name} readOnly />
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">
                Assign To <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control value={item?.resourceName} readOnly />
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md={6}>
              <Form.Label className="fw-bold">
                Task Title <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                value={taskName}
                onChange={(e) => setTaskName(e.target.value)}
              />
              {errors.taskName && <p className="errMsg">{errors.taskName}</p>}
            </Col>

            <Col md={6}>
              <Form.Label className="fw-bold">
                Task Priority <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={taskpriority}
                options={taskPriorityOptions}
                onChange={(option) => setTaskpriority(option)}
              />
              {errors.taskpriority && <p className="errMsg">{errors.taskpriority}</p>}
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md={12}>
              <Form.Label className="fw-bold">
                Task Description <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                value={taskDescription}
                onChange={(e) => setTaskDescription(e.target.value)}
              />
              {errors.taskDescription && <p className="errMsg">{errors.taskDescription}</p>}
            </Col>
          </Row>

          <Row className='mb-4'>
            <Col md={4}>
              <Form.Label className="fw-bold">
                Start Date <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                value={proposedStartDate}
                onChange={(e) => setProposedStartDate(e.target.value)}
              />
              {errors.proposedStartDate && <p className="errMsg">{errors.proposedStartDate}</p>}
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">
                End Date <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                value={proposedEndDate}
                min={proposedStartDate}
                onChange={(e) => setProposedEndDate(e.target.value)}
              />
              {errors.proposedEndDate && <p className="errMsg">{errors.proposedEndDate}</p>}
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">
                Initial Hr <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                value={initialHr}
                onChange={(e) => setInitialHr(e.target.value)}
              />
              {errors.initialHr && <p className="errMsg">{errors.initialHr}</p>}
            </Col>

          </Row>

        </Modal.Body> */}
        <Modal.Body size="lg">

          {/* Row 1 */}
          <Row className='mb-4'>
            <Col md={4}>
              <Form.Label className="fw-bold">
                Assign To <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control value={item?.resourceName} readOnly />
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">
                Department Name <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={departmentName}
                options={departmentOptions}
                onChange={(option) => {
                  setDepartmentName(option);
                  setSubDepartment(null);
                  setAssignto(null);
                }}
              />
              {errors.departmentName && <p className="errMsg">{errors.departmentName}</p>}
            </Col>
            <Col md={4}>
              <Form.Label className="fw-bold">
                SubDepartment Name <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={subDepartment}
                options={subDeptOptions}
                isDisabled={!departmentName}
                onChange={(option) => {
                  setSubDepartment(option)
                  setCategoryname(null)
                }}
              />
              {errors.subDepartment && <p className="errMsg">{errors.subDepartment}</p>}
            </Col>
          </Row>

          {/* Row 2 */}
          <Row className='mb-4'>
            <Col md={6}>
              <Form.Label className="fw-bold">
                Task Title <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                value={taskName}
                onChange={(e) => setTaskName(e.target.value)}
              />
              {errors.taskName && <p className="errMsg">{errors.taskName}</p>}
            </Col>

            <Col md={6}>
              <Form.Label className="fw-bold">
                Task Priority <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={taskpriority}
                options={taskPriorityOptions}
                onChange={(option) => setTaskpriority(option)}
              />
              {errors.taskpriority && <p className="errMsg">{errors.taskpriority}</p>}
            </Col>
          </Row>

          {/* Row 3 */}
          <Row className='mb-4'>
            <Col md={12}>
              <Form.Label className="fw-bold">
                Task Description <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                value={taskDescription}
                onChange={(e) => setTaskDescription(e.target.value)}
              />
              {errors.taskDescription && <p className="errMsg">{errors.taskDescription}</p>}
            </Col>
          </Row>

          {/* Row 4 */}
          <Row className='mb-4'>
            <Col md={6}>
              <Form.Label className="fw-bold">
                Project Name <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                value={projectname}
                options={projectOptions}
                onChange={(option) => {
                  setProjectname(option);
                }}
              />
              {errors.projectname && <p className="errMsg">{errors.projectname}</p>}
            </Col>

            <Col md={6}>
              <Form.Label className="fw-bold">
                Category
                {/* <span className="requiredfield">*</span> */}
              </Form.Label>
              <Select
                value={categoryname}
                options={allCategoriesOptions}
                onChange={(option) => setCategoryname(option)}
              />
              {/* {errors.categoryname && <p className="errMsg">{errors.categoryname}</p>} */}
            </Col>
          </Row>

          {/* Row 5 */}
          <Row className='mb-4'>
            <Col md={4}>
              <Form.Label className="fw-bold">
                Proposed Start Date <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                value={proposedStartDate}
                onChange={(e) => setProposedStartDate(e.target.value)}
              />
              {errors.proposedStartDate && <p className="errMsg">{errors.proposedStartDate}</p>}
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">
                Proposed End Date <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                value={proposedEndDate}
                min={proposedStartDate}
                onChange={(e) => setProposedEndDate(e.target.value)}
              />
              {errors.proposedEndDate && <p className="errMsg">{errors.proposedEndDate}</p>}
            </Col>

            <Col md={4}>
              <Form.Label className="fw-bold">
                Initial Estimate(Hours)<span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                value={initialHr}
                onChange={(e) => setInitialHr(e.target.value)}
              />
              {errors.initialHr && <p className="errMsg">{errors.initialHr}</p>}
            </Col>

            {/* <Col md={3}>
              <Form.Label className="fw-bold">
                Initial Minutes <span className="requiredfield">*</span>
              </Form.Label>
              <Form.Control
                value={initialminute}
                onChange={(e) => setInitialMinute(e.target.value)}
              />
            </Col> */}
          </Row>

        </Modal.Body>
        <Modal.Footer className="text-center mt-4">
          <Button
            className="primaryBtn"
            onClick={(e) => updateTask(e)}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EditTaskModel;
